export const ratingConstants = {
	RatingSettingGetRequest: "RATING_SETTING_GET_STARTED",
	RatingSettingGetSuccess: "RATING_SETTING_GET_COMPLETED",
	RatingSettingGetFailure: "RATING_SETTING_GET_FAILED",

	RatingSettingUpdateRequest: "RATING_SETTING_UPDATE_STARTED",
	RatingSettingUpdateSuccess: "RATING_SETTING_UPDATE_COMPLETED",
	RatingSettingUpdateFailure: "RATING_SETTING_UPDATE_FAILED",

	RatingDashboardRequest: "RATING_DASHBOARD_STARTED",
	RatingDashboardSuccess: "RATING_DASHBOARD_COMPLETED",
	RatingDashboardFailure: "RATING_DASHBOARD_FAILED",

	RatingAppVersionsRequest: "RATING_APP_VERSIONS_STARTED",
	RatingAppVersionsSuccess: "RATING_APP_VERSIONS_COMPLETED",
	RatingAppVersionsFailure: "RATING_APP_VERSIONS_FAILED",

	RatingDeleteRequest: "RATING_DELETE_STARTED",
	RatingDeleteSuccess: "RATING_DELETE_COMPLETED",
	RatingDeleteFailure: "RATING_DELETE_FAILED",
};